import { useTranslations } from "next-intl";

function ValidationSubheader() {
  const t = useTranslations("common");

  return (
    <div className="p-3 bg-white">
      <div className="px-3">
        <h5 className="text-center mb-2">
          {t("drawer.modal_rtc.validate.title")}
        </h5>

        <p className="text-center text-gray mb-0">
          {t("drawer.modal_rtc.validate.subtitle")}
        </p>
      </div>
    </div>
  );
}

export default ValidationSubheader;
